module.exports = __webpack_public_path__ + "static/chardalyn_dragon_mtg_clb-835e01e6c9d1e711f6bbf9e29f0c5de2.webp";